//import { assoc } from 'ramda';
import { Optional, Result } from 'types';
import * as schemaBuilder from 'type-schema';
import { User } from '../type/user';

export type Session = schemaBuilder.buildType<typeof Session.schema>;

const jwtSchema = schemaBuilder.object({
    user: User.schema,
    iat: schemaBuilder.number().transformer(t => t * 1000),
    exp: schemaBuilder.number().transformer(t => t * 1000),
});

export namespace Session {
    export const schema = schemaBuilder.object({
        user: User.schema,
        iat: schemaBuilder.number(),
        exp: schemaBuilder.number(),
        jwt: schemaBuilder.string(),
    });

    export function parse (jwt: string): Result<string, Session> {
        const info = JSON.parse(Buffer.from(jwt.split('.')[1], 'base64').toString('utf-8'));
        const [ error, { user, iat, exp } ] = schemaBuilder.transform(jwtSchema, info);
        return error ? Result.fail(error) : Result.ok({ user, iat, exp, jwt });
    }

    export function save (session: Session) {
        window.localStorage.setItem('session', JSON.stringify(session));
    }

    /** 回傳合法未過期的 session */
    export function load (): Result<string, Optional<Session>> {
        return Optional.of(window.localStorage.getItem('session'))
        .map(JSON.parse)
        .map(sess => {
            const [error, res] = schemaBuilder.transform(schema, sess);
            if (error) {
                return Result.fail<string, Optional<Session>>(error);
            } else {
                if (validate(res)) {
                    return Result.ok<string, Optional<Session>>(Optional.of(res));
                } else {
                    return Result.ok<string, Optional<Session>>(Optional.empty());
                }
            }
        })
        .orElse(Result.ok(Optional.empty()));
    }

    export function validate (session: Session) {
        const now = new Date().getTime();
        return session.exp > now;
    }

    export function clear () {
        window.localStorage.removeItem('session');
    }
}
